import React from 'react';

export const LayoutContext = React.createContext<
  | { layoutRef: React.MutableRefObject<HTMLElement | null>; raw?: boolean }
  | undefined
>(undefined);

export function useScrollLayoutToTarget() {
  const layoutContext = React.useContext(LayoutContext);

  return React.useCallback(
    (target?: HTMLElement | null) => {
      if (target && layoutContext?.layoutRef.current) {
        const targetRect = target.getBoundingClientRect();
        const layoutRect =
          layoutContext.layoutRef.current.getBoundingClientRect();
        const scrollTop =
          targetRect.top -
          layoutRect.top +
          layoutContext.layoutRef.current.scrollTop;

        layoutContext.layoutRef.current.scrollTo({ top: scrollTop });
      }
    },
    [layoutContext],
  );
}
